var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gs-promo-tools-assets"},[_c('promotools',{on:{"logoutAffiliate":_vm.logoutAffiliate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }